var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.item),function(letter,index){return _c('span',{key:index,class:[{ 'sz_red--text': letter.mark === 1 && _vm.marked === true }]},[_vm._v(_vm._s(letter.value))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }